﻿export interface IPaymentResponse {
    id:string
    requestId: string;
    reasonCode: string;
    decisionTypeCode: string;
    merchantReferenceCode: string;
}


export class PaymentResponse implements IPaymentResponse{
    id:string
    requestId: string;
    reasonCode: string;
    decisionTypeCode: string;
    merchantReferenceCode: string;
}

